import { useState } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Card,
  CardBody,
  Container,
} from "reactstrap";

const FAQ = () => {
  const [open, setOpen] = useState("1");

  const toggle = (id:any) => {
    if (open !== id) {
      setOpen(id);
    }
  };

  return (
    <Container className="my-5">
      <Card className="shadow-sm border-0 rounded-4">
        <CardBody className="p-4 p-md-5">
          <div className="text-center mb-4">
            <h2 className="fw-bold">Frequently Asked Questions</h2>
            <p className="text-muted mb-0">
              Everything you need to know before joining a group.
            </p>
          </div>

          <Accordion open={open} toggle={toggle}>
            <AccordionItem>
              <AccordionHeader targetId="1">
                Is joining the group free?
              </AccordionHeader>
              <AccordionBody accordionId="1">
                Yes. Joining the group is completely free.
              </AccordionBody>
            </AccordionItem>

            <AccordionItem>
              <AccordionHeader targetId="2">
                Am I required to join the same institute as everyone else?
              </AccordionHeader>
              <AccordionBody accordionId="2">
                No. Students can choose whichever institute they prefer after
                comparing all available offers.
              </AccordionBody>
            </AccordionItem>

            <AccordionItem>
              <AccordionHeader targetId="3">
                Can I leave the group anytime?
              </AccordionHeader>
              <AccordionBody accordionId="3">
                Yes. You may leave the group at any time before enrollment.
              </AccordionBody>
            </AccordionItem>

            <AccordionItem>
              <AccordionHeader targetId="4">
                Will my phone number be visible?
              </AccordionHeader>
              <AccordionBody accordionId="4">
                No. The on-page group chat keeps your personal information
                private. Sharing your contact details is completely optional.
              </AccordionBody>
            </AccordionItem>

            <AccordionItem>
              <AccordionHeader targetId="5">
                Who negotiates with the institutes?
              </AccordionHeader>
              <AccordionBody accordionId="5">
                Both the PriceWorth coordinator and group members can negotiate
                with coaching institutes. All offers are shared transparently
                with the group.
              </AccordionBody>
            </AccordionItem>
          </Accordion>
        </CardBody>
      </Card>
    </Container>
  );
};

export default FAQ;